import * as type from "./types"

export const fetchTopicsData = () => {
    return { type: type.TOPICS_REQUEST, payload: null }
}

export const resetTopicsData = () => {
    return { type: type.RESET_TOPICS, payload: null }
}